import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4749" />
      <ArchitectureDiagram data-id="element-4750" />
      <HowItWorksConnections mode="how" data-id="element-4751" />
      <LivesInSlack data-id="element-4752" />
      <ComputerUse data-id="element-4753" />
      <CapabilityGrid data-id="element-4754" />
      <NarrativeSection data-id="element-4755" />
      <ToolComparison data-id="element-4756" />
      <WallOfLove data-id="element-4757" />
      <PricingSection data-id="element-4758" />
      <ClosingCTA data-id="element-4759" />
    </>;
}